import { z } from "zod";
import { ThreadAuthor } from "./author.js";
import { FileEntry } from "./file-base.js";
import { ReactionsList } from "./reaction.js";
import { TipTapDocSchema } from "./tiptapDoc.js";

export const ImageContentType = z.enum(["image/jpeg", "image/jpg", "image/png"]);

export const PreviewLink = z.object({
    id: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    url: z.string(),
    title: z.string(),
    description: z.string().optional(),
    image: z.string().optional(),
    postId: z.number().optional(),
});

export const PollState = z.discriminatedUnion("view", [
    z.object({
        view: z.literal("poll"),
        pollOptions: z.array(z.object({ content: z.string(), id: z.number() })),
        totalVotes: z.number(),
    }),
    z.object({
        view: z.literal("results"),
        pollOptions: z.array(
            z.object({
                content: z.string(),
                id: z.number(),
                percent: z.number(),
                votes: z.number(),
                myVote: z.boolean().nullish(),
            }),
        ),
        totalVotes: z.number(),
    }),
]);

export const PostComment = z.object({
    id: z.number(),
    createdAt: z.string(),
    contentJson: TipTapDocSchema,
    author: ThreadAuthor,
    isAnonymous: z.boolean(),
    isUpdated: z.boolean().optional(),
    reactions: ReactionsList,
});

export const Post = z.object({
    id: z.number(),
    createdAt: z.string(),
    contentJson: TipTapDocSchema,
    title: z.string().min(1).max(120),
    author: ThreadAuthor,
    isAnonymous: z.boolean(),
    comments: z.array(PostComment),
    isUpdated: z.boolean().optional(),
    reactions: ReactionsList,
    images: z.array(FileEntry).optional(),
    links: z.array(PreviewLink).optional(),
    userCanEdit: z.boolean(),
    poll: PollState.optional(),
});
